<template>
  <div>
    <v-bottom-sheet
      max-width="500"
      v-model="rowDailog"
      persistent
      inset
      v-if="selectedRow"
    >
      <v-card tile class="touch-view-container rounded-t-xl">
        <v-card-title primary-title>
          <span>{{selectedRow.name}}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop.prevent="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mb-0">
          <v-item-group v-model="selectedDate" mandatory active-class="warning">
            <v-container>
              <v-row>
                <v-col :value="n" v-for="n in list" :key="n.name" cols="6">
                  <v-item v-slot="{ active, toggle }">
                    <v-card
                      class="d-flex align-center"
                      dark
                      height="70"
                      @click="toggle"
                    >
                      <v-scroll-y-transition>
                        <div
                          v-if="active"
                          class="text-h6 flex-grow-1 text-center"
                        >
                          {{ n.name }}
                        </div>
                        <div v-else class="text-h6 flex-grow-1 text-center">
                          {{ n.name }}
                        </div>
                      </v-scroll-y-transition>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>
          <div class="text-center mt-1">
            {{ dateTime.start | moment("MM/DD/YYYY") }} -
            {{ dateTime.end | moment("MM/DD/YYYY") }}
          </div>
        </v-card-text>
        <div class="text-center" v-if="loading">
          <v-progress-circular
            :width="3"
            color="red"
            indeterminate
          ></v-progress-circular>
          <div>
            please wait
          </div>
        </div>
        <v-card v-else flat >
          <v-list dense class="touch-view-day-row">
            <template v-for="(row, i) in Object.keys(unGroupList)">
              <v-list-item
                @click.stop.prevent="
                  openDetail(Object.entries(unGroupList)[i][1])
                "
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <v-row align="center">
                      <v-col
                        >{{
                          Object.entries(unGroupList)[i][1].row[0].clockInTime
                            | moment("dddd")
                        }}
                        - {{ row }}
                      </v-col>
                      <v-col class="shrink">{{
                        Object.entries(unGroupList)[i][1].row.length
                      }}</v-col>
                    </v-row>
                  </v-list-item-title>

                  <v-progress-linear
                    :color="barColor(Object.entries(unGroupList)[i][1])"
                    height="25"
                    :value="
                      duration(
                        Object.entries(unGroupList)[i][1].totalInSeconds,
                        Object.entries(unGroupList)[i][1].metadata
                      )
                    "
                    striped
                  >
                  </v-progress-linear>
                  <v-list-item-subtitle>
                    <v-row align="center">
                      <v-col
                        v-if="
                          Object.entries(unGroupList)[i][1].row[0]
                            .TimeClockPayId
                        "
                        class="shrink pr-0"
                      >
                        <v-chip
                          label
                          small
                          style="height: 20px; font-size: 10px"
                          text-color="white"
                          color="red"
                          >Paid</v-chip
                        >
                      </v-col>

                      <v-col
                        v-if="employeeAccess.report && employeeAccess.report.showHours"
                      >
                        {{
                          secondsToHms(
                            Object.entries(unGroupList)[i][1].totalInSeconds
                          )
                        }}
                        <span
                          v-if="Object.entries(unGroupList)[i][1].astrid"
                          class="red--text"
                          >* <strong>Not counted in pay!</strong></span
                        >
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col
                        class="text-right"
                        v-if="Object.entries(unGroupList)[i][1].early"
                      >
                        <span class="red--text" v-if="employeeAccess.report && employeeAccess.report.showHours">{{
                          secondsToHms(Object.entries(unGroupList)[i][1].early)
                        }}</span>
                      </v-col>
                    </v-row>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="i + 1 < Object.keys(unGroupList).length"
                :key="i"
              ></v-divider>
            </template>
          </v-list>
        </v-card>
        <DayDetail
          @submit="dataSave"
          @close="dayDetailDialog = false"
          :dialog="dayDetailDialog"
          :selectedRow="daySelected"
        />
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
// import EmployeeReport from "@/modules/Reports/components/DetailReports.vue";
import _ from "lodash";
import timeClockService from "@/modules/TimeClock/service";
import { mapGetters } from "vuex";
import DayDetail from "@/modules/Reports/components/DayDetail.vue";

export default {
  name: "quick-repot",
  props: ["dialog", "selectedRow"],
  data() {
    return {
      daySelected: null,
      dayDetailDialog: false,
      reload: false,
      totalSeconds: 0,
      unGroupList: [],
      workingHours: 12,
      selectedDate: 1,
      loading: false,
      list: [
        {
          name: "Last Week",
          start: this.$moment()
            .subtract(1, "week")
            .startOf("week")
            .toISOString(),
          end: this.$moment().subtract(1, "week").endOf("week").toISOString(),
        },
        {
          name: "This Week",
          start: this.$moment().startOf("week").toISOString(),
          end: this.$moment().endOf("week").toISOString(),
        },
      ],
      rowDailog: false,
      dateTime: {
        start: this.$moment().startOf("week").toISOString(),
        end: this.$moment().endOf("week").toISOString(),
      },
    };
  },
  watch: {
    selectedDate(i) {
      this.dateTime.start = this.list[i].start;
      this.dateTime.end = this.list[i].end;
      this.loadTimeClock();
    },
    dialog(val) {
      this.rowDailog = val;
      if (val) {
        this.loadTimeClock();
      }
      // console.log("selectedRow", this.selectedRow);
    },
  },
  computed: {
    ...mapGetters("employee", ["employeeAccess"]),
  },
  components: {
    DayDetail,
  },
  methods: {
    close() {
      this.selectedDate = 1

      this.$emit("close");
    },
    openDetail(row) {
      this.daySelected = row;
      this.reload = true;
      this.dayDetailDialog = !this.dayDetailDialog;
    },
    duration(seconds) {
      let value = 10;

      const totalTime = this.workingHours * 60 * 60;
      // console.log('row', row, totalTime)
      value = (seconds / totalTime) * 100;
      return value;
    },
    barColor(obj) {
      // :color="Object.entries(unGroupList)[i][1].astrid ? 'light-blue darken-1' : 'light-green darken-1'"
      // console.log('obj', obj)
      let value = "light-green darken-1";
      let totalSeconds = this.workingHours * 60 * 60;

      totalSeconds = this.workingHours * 60 * 60;
      if (obj.totalInSeconds < totalSeconds) {
        value = "red darken-1";
      }
      if (!obj.astrid && obj.totalInSeconds < totalSeconds) {
        obj.early = totalSeconds - obj.totalInSeconds;
      }

      if (obj.astrid) {
        value = "light-blue darken-1";
      }

      return value;
    },
    secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);

      // console.log('AndDown', this.$vuetify.breakpoint.xsOnly)

      var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";

      if (this.$vuetify.breakpoint.xsOnly) {
        hDisplay = h > 0 ? h + " h, " : "";
        mDisplay = m > 0 ? m + " m, " : "";
        sDisplay = s > 0 ? s + " s " : "";
      }

      return hDisplay + mDisplay + sDisplay;
    },
    dataSave() {
      this.reload = true;
      this.loadTimeClock();
       this.dayDetailDialog = false
      this.dialog = false;
    },
    loadTimeClock() {
      console.log("loading data");
      this.loading = true;
      this.unGroupList = [];
      const dataObj = {
        start: this.dateTime.start,
        end: this.dateTime.end,
        EmployeeId: this.selectedRow.id,
      };
      // console.log("dataObj", dataObj);
      return timeClockService
        .getEmployeeTimeClockReport(dataObj)
        .then((response) => {
          // console.log("loadTimeClock", response);
          this.totalSeconds = 0;
          this.unGroupList = _.mapValues(
            _.groupBy(response.data.timeClockList, (row) => {
              if (row.TimeClockPayId) this.showPayBtn = false;
              return this.$moment(row.clockInTime).format("MM/DD/YYYY");
            }),
            (list) => {
              // console.log('printing list', list)
              // let newlist = []
              if (list.length > 1) {
                let seconds = 0;
                let astrid = false;
                list.map((row) => {
                  if (row.clockOutTime) {
                    seconds += row.shiftDuration.totalInSeconds;
                    this.totalSeconds += row.shiftDuration.totalInSeconds;
                  } else {
                    astrid = true;
                  }
                });
                // newlist.push({
                //     createdAt: list[0].createdAt,
                //     totalInSeconds: seconds
                // })
                return {
                  clockInTime: list[0].clockInTime,
                  astrid,
                  totalInSeconds: seconds,
                  metadata: list[0].Employee.metadata,
                  row: list,
                };
              } else {
                this.totalSeconds += list[0].shiftDuration.totalInSeconds;
                return {
                  id: list[0].id,
                  clockInTime: list[0].clockInTime,
                  astrid: list[0].clockOutTime ? false : true,
                  totalInSeconds: list[0].shiftDuration.totalInSeconds,
                  metadata: list[0].Employee.metadata,
                  row: list,
                };
              }
            }
          );

          this.timeClockList = response.data.timeClockList;
          this.totalTime = response.data.totalTime;
          this.count = this.timeClockList.length;
          if (!this.empData) {
            if (this.timeClockList.length > 1) {
              this.empData = this.timeClockList[0].Employee;
            }
          }
          // console.log("this.unGroupList", this.unGroupList);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log("error is :", error);
        });
    },
  },
};
</script>

<style scoped>
.touch-view-day-row {
  height: calc(100vh - 325px);
  width: 100%;
  overflow: auto;
}
</style>